var exports = {
  "l": "Banner__QxCngJ",
};

module.exports = exports;
